import Gleap from 'gleap';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIGURATION, AppConfigurationService, IAppConfigurationBase } from './app-configuration.service';

@Injectable({ providedIn: 'root' })
export class GleapService {
  initialized = false;
  constructor(@Inject(APP_CONFIGURATION) private configuration: AppConfigurationService<IAppConfigurationBase>) {
  }

  initGleap = () => {
    if (this.initialized) { return; }

    const gleapKey = this.configuration.data?.keys?.gleapKey;
    const hostname = window.document.location.hostname;
    const envMode = hostname === 'nexpark.umojodev.com' ? 'demo' : hostname.includes('umojodev') ? 'dev' : 'prod';
    if (envMode) {
      if (gleapKey) {
        Gleap.initialize(gleapKey);
        Gleap.showFeedbackButton(true);
        this.initialized = true;
      }
      if (envMode !== 'prod') {
        Gleap.setEnvironment('dev');
      }
    }
  }
  identifyGleapUser = (username: string, GrmUserId: string, email: string) => {
    const gleapKey = this.configuration.data?.keys?.gleapKey;
    if (!gleapKey) { return; }
    const baseUrl = this.configuration.data?.paths?.baseUrl;
    Gleap.clearIdentity();
    Gleap.identify(GrmUserId, {
      name: username,
      email: email,
      companyName: baseUrl ? this.prepareCustomerName(baseUrl) : 'not identified',
    });
  }

  clearAndCloseGleap() {
    const gleapKey = this.configuration.data?.keys?.gleapKey;
    if (!gleapKey) { return; }
    Gleap.clearIdentity();
    Gleap.close();
    Gleap.destroy();
  }

  private prepareCustomerName = (baseUrl: string): string => {
    let domain = baseUrl.replace(/https?:\/\//, '').split('.com')[0];
    if (domain.includes('admin.')) {
      domain = domain.split('admin.')[1];
    }
    return domain;
  }


}



